const maxWidthMap = {
  large: '640px',
  lg: '640px',
  small: '320px',
  sm: '320px',
  largeOnXS: '100%',
  fullScreen: '100%'
};
const widthMap = {
  large: '90%',
  lg: '90%',
  small: 'auto',
  sm: 'auto',
  largeOnXS: '100%',
  fullScreen: '100%'
};
const contentPaddingMap = {
  small: '0px 24px 0px 24px',
  sm: '0px 24px 0px 24px',
  large: '0px 32px 0px 32px',
  lg: '0px 32px 0px 32px',
  largeOnXS: '0px 16px 0px 16px',
  fullScreen: '0px 32px 0px 32px'
};
const actionsPaddingMap = {
  small: '20px 24px 24px 24px',
  sm: '20px 24px 24px 24px',
  large: '20px 32px 32px 32px',
  lg: '20px 32px 32px 32px',
  largeOnXS: '8px 16px 8px 8px',
  fullScreen: '20px 16px 32px 32px'
};
export const modalDefaultStyle = (theme, size, padding) => ({
  '.MuiDialog-paper': {
    borderRadius: theme.tokens.ComponentModalBorderRadius,
    boxShadow: `0px 0px 6px ${theme.tokens.ComponentModalBoxShadowColor}`,
    '&.MuiDialog-paperFullScreen': {
      borderRadius: '0px',
      border: 'none'
    },
    maxWidth: maxWidthMap[size],
    maxHeight: '80vh',
    width: widthMap[size]
  },
  '& .MuiDialogContent-root': {
    ...(padding ? {
      padding: contentPaddingMap[size]
    } : {
      padding: 0
    }),
    '& p': {
      margin: '0px',
      fontSize: theme.tokens.ComponentModalBodyFontSize,
      color: theme.tokens.ComponentModalBodyColor,
      fontFamily: theme.tokens.ComponentModalBodyFontFamily,
      fontWeight: theme.tokens.ComponentModalBodyFontWeight,
      lineHeight: '125%',
      fontVariationSettings: "'opsz' 16"
    }
  },
  '& .MuiDialogActions-root': {
    padding: actionsPaddingMap[size],
    borderBottom: 'none',
    boxSizing: 'border-box',
    borderTop: size === 'largeOnXS' ? `1px solid ${theme.tokens.ComponentModalBorderColor}` : 'none',
    backgroundColor: theme.tokens.ComponentModalFooterBackgroundColor
  },
  '& .MuiDialog-container': {
    height: '100%'
  },
  '& .MuiBackdrop-root': {
    backgroundColor: `color-mix(in srgb,${theme.tokens.ComponentModalBackdropColor} 80%, transparent)`
  },
  '& ~ .interstate-reference': {
    zIndex: 1300
  }
});